import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import zoomPlugin from 'chartjs-plugin-zoom';
import { faExpand, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Chart, CategoryScale, LinearScale, TimeScale, BarElement, Title, Tooltip, Legend, PointElement, BubbleController } from 'chart.js';
import { executeQuery } from './executeQuery';

Chart.register(CategoryScale, LinearScale, TimeScale, BarElement, Title, Tooltip, Legend, zoomPlugin, PointElement, BubbleController);


const ChartPanel = ({
    setFeedbackData
}) => {
    
    const [trafficCounts, setTrafficCounts] = useState([]);
    const [fullScreenChart, setFullScreenChart] = useState(null);
    const [startDate, setStartDate] = useState(''); // !!!!!!!!!
    const [endDate, setEndDate] = useState(''); // !!!!!!!!!
    const [messageCounts, setMessageCounts] = useState({
        webApp: [],
        discord: [],
      });

      const trafficChartData = {
        labels: trafficCounts.map((item) => item.date),
        datasets: [
          {
            label: 'Web App Traffic',
            data: trafficCounts.map((item) => item.webApp) || [],
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            borderRadius: 5,
          },
          {
            label: 'Discord Bot Traffic',
            data: trafficCounts.map((item) => item.discord) || [],
            backgroundColor: 'rgba(255, 159, 64, 0.5)',
            borderColor: 'rgba(255, 159, 64, 1)',
            borderWidth: 2,
            borderRadius: 5,
          },
        ],
      };

      const messageChartData = {
        labels: [
          ...new Set([
            ...messageCounts.webApp.map((item) => item.date),
            ...messageCounts.discord.map((item) => item.date),
          ]),
        ],
        datasets: [
          {
            label: 'Web App Messages',
            data: messageCounts.webApp.map((item) => item.count),
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            borderRadius: 5,
          },
          {
            label: 'Discord Messages',
            data: messageCounts.discord.map((item) => item.count),
            backgroundColor: 'rgba(255, 159, 64, 0.5)',
            borderColor: 'rgba(255, 159, 64, 1)',
            borderWidth: 2,
            borderRadius: 5,
          },
        ],
      };

    const fetchTrafficCounts = async () => {
        const discordQuery = `
        SELECT DATE(date) as date, COUNT(DISTINCT user_id) as count 
        FROM conversations
        GROUP BY DATE(date)
        ORDER BY DATE(date);
        `;
    
        const query = `
          SELECT DATE(timestamp) as date, COUNT(DISTINCT user_id) as count 
          FROM conversation_website
          GROUP BY DATE(timestamp)
          ORDER BY DATE(timestamp)
        `;
    
        try {
          const webAppResults = await executeQuery(query);
          const discordResults = await executeQuery(discordQuery);
          const dateMap = {};
    
          webAppResults.forEach((item) => {
            dateMap[item.date] = { webApp: item.count, discord: 0 };
          });
    
          discordResults.forEach((item) => {
            if (dateMap[item.date]) {
              dateMap[item.date].discord = item.count;
            } else {
              dateMap[item.date] = { webApp: 0, discord: item.count };
            }
          });
    
          const alignedData = Object.keys(dateMap)
            .sort((a, b) => new Date(a) - new Date(b))
            .map((date) => ({
              date,
              webApp: dateMap[date].webApp,
              discord: dateMap[date].discord,
            }));
    
          setTrafficCounts(alignedData);
        } catch (error) {
          console.error('Error fetching traffic counts:', error);
        }
      };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: '' },
            zoom: {
                pan: {
                    enabled: true,
                    mode: 'x',
                },
                zoom: {
                    wheel: {
                        enabled: true,
                    },
                    pinch: {
                        enabled: true,
                    },
                    mode: 'x',
                },
            },
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    tooltipFormat: 'yyyy-MM-dd hh:mm:ss',
                    displayFormats: {
                        day: 'yyyy-MM-dd',
                    },
                },
                adapters: {
                    date: {
                        zone: 'Europe/Amsterdam',
                    },
                },
            },
            y: { beginAtZero: true },
        },
    };

    const handleFullScreen = (chartId) => {
        setFullScreenChart(chartId);
    };

    const closeFullScreen = () => {
        setFullScreenChart(null);
    };

    const resetZoom = () => {
        Chart.getChart('messageChart').resetZoom();
        Chart.getChart('trafficChart').resetZoom();
    };

    const fetchFeedback = async () => {
        const webAppQuery = `
          SELECT message, is_positive, timestamp, 
          'web' AS source
          FROM conversation_website
          WHERE is_positive IS NOT NULL;
        `;
    
        const discordQuery = `
        SELECT user_id, 
          response AS message, 
          liked_reply AS is_positive, 
          date AS timestamp, 
          'discord' AS source
        FROM conversations 
        WHERE liked_reply IS NOT NULL;
        `
    
        try {
          // Execute both queries
          const webAppResults = await executeQuery(webAppQuery);
          const discordResults = await executeQuery(discordQuery);
      
          // Combine results into a single array
          const combinedResults = [
            ...(webAppResults || []),
            ...(discordResults || []),
          ];
      
          // console.log(combinedResults, "feedback results");
          // Update state
          setFeedbackData(combinedResults);
        } catch (error) {
          console.error('Error fetching feedback:', error);
          setFeedbackData([]); // Reset feedback data on error
        }
      };

    const fetchMessageCounts = async () => {
        const webAppQuery = `
          SELECT DATE(timestamp) as date, COUNT(*) as count
          FROM conversation_website
          GROUP BY DATE(timestamp)
          ORDER BY DATE(timestamp);
        `;
    
        const discordQuery = `
          SELECT DATE(date) as date, COUNT(*) as count
          FROM conversations
          GROUP BY DATE(date)
          ORDER BY DATE(date);
        `;
    
        try {
          const webAppResults = await executeQuery(webAppQuery);
          const discordResults = await executeQuery(discordQuery);
    
          setMessageCounts({
            webApp: webAppResults || [], // Web app message counts
            discord: discordResults || [], // Discord message counts
          });
        } catch (error) {
          console.error('Error fetching message counts:', error);
          setMessageCounts({
            webApp: [],
            discord: [],
          });
        }
      };

    useEffect(() => {
        fetchFeedback();
        fetchMessageCounts();
        fetchTrafficCounts();
        
    }, [startDate, endDate]);



    return (
        <div className="table-responsive">
            <div className="row">
                {/* Message Chart */}
                <div className="col-md-6">
                    <div className="position-relative">
                        <h4 className="text-center">Message Count Over Time</h4>
                        <FontAwesomeIcon
                            icon={faExpand}
                            className="position-absolute top-0 end-0 m-2"
                            style={{ cursor: "pointer", fontSize: "1.2rem" }}
                            onClick={() => handleFullScreen("messageChart")}
                        />
                    </div>
                    <div id="messageChartContainer">
                        <Bar
                            id="messageChart"
                            data={messageChartData}
                            options={{
                                ...chartOptions,
                                plugins: {
                                    ...chartOptions.plugins,
                                    title: { display: true, text: "Messages per Day" },
                                },
                            }}
                        />
                    </div>
                </div>

                {/* Traffic Chart */}
                <div className="col-md-6">
                    <div className="position-relative">
                        <h4 className="text-center">Traffic Over Time</h4>
                        <FontAwesomeIcon
                            icon={faExpand}
                            className="position-absolute top-0 end-0 m-2"
                            style={{ cursor: "pointer", fontSize: "1.2rem" }}
                            onClick={() => handleFullScreen("trafficChart")}
                        />
                    </div>
                    <div id="trafficChartContainer">
                        <Bar
                            id="trafficChart"
                            data={trafficChartData}
                            options={{
                                ...chartOptions,
                                plugins: {
                                    ...chartOptions.plugins,
                                    title: { display: true, text: "Unique Users per Day" },
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Reset Zoom Button */}
            <button className="btn btn-primary mt-3" onClick={resetZoom}>
                Reset Zoom
            </button>

            {/* Fullscreen Modal */}
            {fullScreenChart && (
                <div
                    className="fullscreen-modal-overlay"
                    onClick={closeFullScreen}
                >
                    <div
                        className="fullscreen-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FontAwesomeIcon
                            icon={faTimes}
                            className="close-icon"
                            style={{
                                cursor: "pointer",
                                fontSize: "1.2rem",
                            }}
                            onClick={closeFullScreen}
                        />
                        {fullScreenChart === "messageChart" && (
                            <Bar
                                data={messageChartData}
                                options={{
                                    ...chartOptions,
                                    plugins: {
                                        ...chartOptions.plugins,
                                        title: { display: true, text: "Messages per Day (Fullscreen)" },
                                    },
                                }}
                            />
                        )}
                        {fullScreenChart === "trafficChart" && (
                            <Bar
                                data={trafficChartData}
                                options={{
                                    ...chartOptions,
                                    plugins: {
                                        ...chartOptions.plugins,
                                        title: { display: true, text: "Traffic Over Time (Fullscreen)" },
                                    },
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChartPanel;
